import {
  LightboxService,
  PhotoSwipeItem,
} from "features/gallery/lightbox/lightbox.service"
import { getHighlights } from "features/events/highlights/highlights.functions"
import { GalleryService } from "features/gallery/service/gallery.service"
import { getContextName, ViewContext } from "concerns/useContextName"
import { GroupMember } from "suus-api"

export const useEventHighlightPhotoswipe = (
  eventId: number,
  galleryService: GalleryService,
  lightboxService: LightboxService,
  viewContext: ViewContext
) => {
  const loadHighlight = async (index: number): Promise<PhotoSwipeItem> => {
    const highlights = await getHighlights(eventId, index, 1)
    const originalFile = highlights[0]?.event_medium.uploaded_file.original
    const author: GroupMember =
      highlights[0]?.event_medium.uploaded_file.uploaded_by
    const contextAuthorName = getContextName(viewContext, author)
    return {
      src: originalFile.url,
      width: originalFile.width,
      height: originalFile.height,
      authorName: contextAuthorName,
    }
  }

  const highlightsCount = galleryService.highlightsCount
  const openLightbox = (index: number) => {
    lightboxService.openPhotoLightbox(
      index,
      highlightsCount.value,
      loadHighlight
    )
  }

  return {
    openLightbox,
  }
}
